module.exports = __webpack_public_path__ + "static/sign-up-bg-8a64f2b54c17ce6eb45b1d97b98c6e2f.png";